/**
 * Created by Omar Alejandro Leonor Avalos on 2017-08-03.
 */
import React, { Component } from 'react';
import moment from 'moment';

class GeneralInfo extends Component {
    render() {
        const {
            supplier,
            weight,
            requestingPaymentTimestamp,
            requestingNumber,
            customsValue,
            merchandiseDescription,
            comertialInvoiceNumber,
            folio,
            customsHouse: { name }
        } = this.props;

        return (
            <div className="row padding-2 prefactura-info">
                <div className="col-xs-3">
                    <p className="text-bold text-color-light">Folio del Despacho</p>
                    <h5>{folio}</h5>
                </div>
                <div className="col-xs-3">
                    <p className="text-bold text-color-light">Pedimento</p>
                    <h5>{requestingNumber}</h5>
                </div>
                <div className="col-xs-3">
                    <p className="text-bold text-color-light">Fecha Pedimento</p>
                    <h5>{moment(requestingPaymentTimestamp).format('DD-MM-YYYY')}</h5>
                </div>
                <div className="col-xs-3">
                    <p className="text-bold text-color-light">Peso</p>
                    <h5>{weight} Kg</h5>
                </div>
                <div className="col-xs-3">
                    <p className="text-bold text-color-light">Valor Aduanal</p>
                    <h5>{customsValue}</h5>
                </div>
                <div className="col-xs-3">
                    <p className="text-bold text-color-light">Proveedor</p>
                    <h5>{supplier.name}</h5>
                </div>
                <div className="col-xs-3">
                    <p className="text-bold text-color-light">Factura Comercial</p>
                    <h5>{comertialInvoiceNumber}</h5>
                </div>
                <div className="col-xs-6">
                    <p className="text-bold text-color-light">Aduana</p>
                    <h5>{name}</h5>
                </div>
                <div className="col-xs-6">
                    <p className="text-bold text-color-light">Descripción</p>
                    <h5>{merchandiseDescription}</h5>
                </div>
            </div>
        );
    }
}

export default GeneralInfo;



// WEBPACK FOOTER //
// ./forms/customPrefactura/generalInfo.js